import { createContext } from "react";

export const WidjetContext = createContext();